import {
    Component,
    Input,
    NgModuleRef,
    NgZone,
    ChangeDetectionStrategy,
} from '@angular/core';
import { ModalService } from 'mnm-webapp';
import { Subject } from 'rxjs';
import { functions } from '@masar/common/misc/functions';
import { LibraryFile } from '@masar/common/models';
import { FileViewerComponent } from '../file-viewer/file-viewer.component';
import { LibraryFileNameService } from './library-file-name.service';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'app-library-file-name',
    providers: [LibraryFileNameService],
    template: `
        @if (isLoading) {
            <div
                class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
            >
                <div>
                    <div class="sk-chase">
                        <div class="sk-chase-dot"></div>
                        <div class="sk-chase-dot"></div>
                        <div class="sk-chase-dot"></div>
                        <div class="sk-chase-dot"></div>
                        <div class="sk-chase-dot"></div>
                        <div class="sk-chase-dot"></div>
                    </div>
                </div>
            </div>
        }
        @if (libraryFile.hasFile) {
            <a
                href="#"
                onclick="return false"
                (click)="
                    download(
                        libraryFile.id,
                        libraryFile.contentType,
                        libraryFile.name
                    )
                "
            >
                {{ libraryFile.name }}
            </a>
        }
        @if (libraryFile.link && !libraryFile.hasFile) {
            <a href="{{ libraryFile.link }}" target="_blank">
                {{ libraryFile.name }}
            </a>
        }
        @if (!libraryFile.link && !libraryFile.hasFile) {
            {{ libraryFile.name }}
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class LibraryFileNameComponent {
    @Input() public libraryFile: LibraryFile;

    public isLoading = false;

    public constructor(
        private libraryFileNameService: LibraryFileNameService,
        private ngZone: NgZone,
        private moduleRef: NgModuleRef<any>,
        private modalService: ModalService
    ) {}

    public download(id: string, type: string, fileName: string): void {
        this.isLoading = true;

        this.libraryFileNameService
            .download(id)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe(file => {
                if (file) {
                    // Ensure file is defined before proceeding
                    if (
                        type === 'application/pdf' ||
                        type.split('/')[0] === 'image'
                    ) {
                        const src = URL.createObjectURL(file);
                        this.showFileModal(src, fileName, type);
                    } else {
                        this.ngZone.runOutsideAngular(() => {
                            functions.downloadBlobIntoFile(file, fileName);
                        });
                    }
                }
            });
    }

    public showFileModal(
        src: string,
        fileName: string,
        contentType: string = ''
    ): void {
        const subject = new Subject<void>();
        this.modalService.show(FileViewerComponent, {
            moduleRef: this.moduleRef,
            onDismiss: () => {
                window.URL.revokeObjectURL(src);
                subject.next();
                subject.complete();
            },
            beforeInit: c => {
                c.src = src;
                c.fileName = fileName;
                c.contentType = contentType;
            },
            size: {
                width: '100%',
                height: '100%',
            },
        });
    }
}
